import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (<>
    <Helmet>
       <link rel="canonical" href="/"/>
       <title>404: This page could not be found</title>
   </Helmet>

    <Container fluid className="d-flex justify-content-center align-items-center Error_page">
      <Row className="text-center my-4 py-4">
        <Col>
          <div className="my-lg-5 my-4 py-lg-5 py-2">
            <h1 className="display-1 fw-bold text-black">404</h1>
            <h2 className="fw-medium mb-md-3 mb-2">Oops! Page Not Found</h2>
            <p className="lead mb-4">
              The page you are looking for does not exist.
            </p>
            <Link to="/">
              <Button size="lg" className='px-5' style={{backgroundColor:"#000", borderColor:"#000", color:"#fff", fontSize:"18px", fontWeight:"400"}}>Go to Home</Button>
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
    </>);
};

export default NotFound;
